import { addToCompare, removeFromCompare } from "../../redux/compareProductsReducer"
import { useCompareCount } from "../../redux/hook/compareHooks"
import { strings as Localization } from "../../lib/Localization"
import { setSnackbarMessage } from "../../redux/userMessageSlice"
import React from "react"
import { IconButton, Tooltip } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import CompareIcon from "@mui/icons-material/Compare"
import { styled } from "@mui/styles"
import { useCookieConsent } from "react-cookie-manager"

const ConsentWrapper = styled("div")(() => (
    {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "8px",
        padding: "20px"
    }
))

const ConsentTitle = styled("div")(() => (
    {
        flex: "0 1 100%",
        textAlign: "center",
        fontFamily: "Arial",
        fontSize: "14px"
    }
))

const ConsentButton = styled("button")(() => (
    {
        fontWeight: 700,
        backgroundColor: "#F09057",
        border: 0,
        borderRadius: "6px",
        padding: "5px 10px",
        cursor: "pointer"
    }
))

const ConsentMessage = () => {
    const { showConsentBanner } = useCookieConsent()

    return (
        <ConsentWrapper>
            <ConsentTitle>
                {Localization.consentCookiesPrompt}
            </ConsentTitle>
            <ConsentButton
                type="button"
                onClick={showConsentBanner}
            >
                {Localization.manageConsentButtonText}
            </ConsentButton>
        </ConsentWrapper>
    )
}

export default ConsentMessage
